// 88927: About Me has no Japanese (17) or Hungarian (67) text, so picking one shows a blank page.
const ABOUT_ME_INSTRUMENT_ID = 2946;
const ABOUT_ME_UNSUPPORTED_LANGUAGE_IDS = [17, 67];

export const hideUnsupportedAboutMeLanguages = <T extends { languageId: number }>(
	instrumentId: number | undefined,
	languages: T[]
): T[] =>
	instrumentId === ABOUT_ME_INSTRUMENT_ID
		? languages.filter((l) => !ABOUT_ME_UNSUPPORTED_LANGUAGE_IDS.includes(l.languageId))
		: languages;
